import AtSignIcon from "@redotech/redo-icons/at-sign_filled.svg";
import CalendarIcon from "@redotech/redo-icons/calendar.svg";
import CheckIcon from "@redotech/redo-icons/check-verified-02.svg";
import MessageIcon from "@redotech/redo-icons/message-text-square-02.svg";
import NotificationMessageIcon from "@redotech/redo-icons/notification-message.svg";
import PhoneIcon from "@redotech/redo-icons/phone-01.svg";
import TagIcon from "@redotech/redo-icons/tag-01.svg";
import UserIcon from "@redotech/redo-icons/user-01.svg";
import { FilterGroupFilterOption } from "@redotech/redo-model/conversation-filters/conversation-filters";
import { JSXElementConstructor } from "react";

export const ConversationFilterOptionToIcon: Record<
  FilterGroupFilterOption,
  JSXElementConstructor<any>
> = {
  [FilterGroupFilterOption.ASSIGNEES]: UserIcon,
  [FilterGroupFilterOption.CHANNELS]: PhoneIcon,
  [FilterGroupFilterOption.CONVERSATION_TAGS]: TagIcon,
  [FilterGroupFilterOption.CREATED_DATE]: CalendarIcon,
  [FilterGroupFilterOption.CLOSED_DATE]: CalendarIcon,
  [FilterGroupFilterOption.LAST_RESPONSE_AT]: CalendarIcon,
  [FilterGroupFilterOption.WORDS]: MessageIcon,
  [FilterGroupFilterOption.CUSTOMER_TAGS]: UserIcon,
  [FilterGroupFilterOption.READ]: NotificationMessageIcon,
  [FilterGroupFilterOption.MENTIONS]: AtSignIcon,
  [FilterGroupFilterOption.AI_MERCHANT_APPROVAL]: CheckIcon,
};

export const ConversationFilterOptionToName: Record<
  FilterGroupFilterOption,
  string
> = {
  [FilterGroupFilterOption.ASSIGNEES]: "Assignee",
  [FilterGroupFilterOption.CHANNELS]: "Platform",
  [FilterGroupFilterOption.CONVERSATION_TAGS]: "Tags",
  [FilterGroupFilterOption.CREATED_DATE]: "Created date",
  [FilterGroupFilterOption.CLOSED_DATE]: "Closed date",
  [FilterGroupFilterOption.LAST_RESPONSE_AT]: "Last customer message",
  [FilterGroupFilterOption.WORDS]: "Message content",
  [FilterGroupFilterOption.CUSTOMER_TAGS]: "Customer tags",
  [FilterGroupFilterOption.READ]: "Read status",
  [FilterGroupFilterOption.MENTIONS]: "User mentions",
  [FilterGroupFilterOption.AI_MERCHANT_APPROVAL]: "AI merchant approval",
};
